module.exports = __webpack_public_path__ + "img/teaser_richy.80c4edd1.jpg";